module.exports = __webpack_public_path__ + "img/cave-vin-blanc-en-ligne-boutrais.5b3fe27d.png";